"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPlanModuleGenerationTaskBase = void 0;
/* eslint-disable require-jsdoc */
const constants_1 = require("../constants");
class DayPlanModuleGenerationTaskBase {
    constructor(uid, date, moduleId) {
        this.state = "PENDING";
        this.errorMessage = null;
        this.uid = uid;
        this.dateStrShort = date.toISOString().split("T")[0];
        this.moduleId = moduleId;
    }
    static collectionPath(uid, taskId) {
        // eslint-disable-next-line max-len
        return `${constants_1.constants.COLLECTION_PATH_APPLICATION_PROFILE}/${uid}/${constants_1.constants.COLLECTION_PATH_DAY_PLAN_GENERATION_TASK}/${taskId}/${constants_1.constants.COLLECTION_PATH_DAY_PLAN_MODULE_GENERATION_TASK}`;
    }
}
exports.DayPlanModuleGenerationTaskBase = DayPlanModuleGenerationTaskBase;
